import { addPositiveToast } from 'modules/toastContainer';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { ApiError } from 'services/api';
import { useModalContext } from 'utils/contexts/modal';
import { MappingFieldValues } from '../types';

type UseCreateFieldModalProps = {
  refetch: () => void;
};

export const useCreateFieldModal = ({ refetch }: UseCreateFieldModalProps) => {
  const dispatch = useDispatch();
  const { hideModal } = useModalContext();

  const [hasError, setHasError] = useState(false);

  const {
    formState: { isSubmitting, isSubmitted, isValid },
    getValues,
    handleSubmit,
    setError,
  } = useFormContext<MappingFieldValues>();

  const isDisabled = isSubmitted && !isValid;

  const onError = (e: unknown) => {
    const responseData = (e as ApiError)?.response?.data;
    if (responseData === 'string') {
      // sets known errors on input field
      setError('fieldName', { type: 'custom', message: responseData });
    } else {
      // set unknown errors flag to show error banner
      setHasError(true);
    }
  };

  const onSuccess = () => {
    const fieldName = getValues('fieldName');
    dispatch(addPositiveToast(`Successfully created ${fieldName}.`));
    refetch();
    hideModal();
  };

  return {
    hasError,
    isDisabled,
    isSubmitting,
    onError,
    handleSubmit,
    onClose: hideModal,
    onSuccess,
  };
};
